import React from "react";
import Header2 from "./Header2";
import Footer from "./Footer";
import { useTheme } from "../../utils/theme";

export default function Layout({ children }) {
    const { theme } = useTheme();

    return (
        <div
            className="d-flex flex-column min-vh-100"
            style={theme === "dark" ? { backgroundColor: "#000000" } : undefined}
        >
            <Header2 />

            {/* Page Content */}
            <main className="flex-grow-1">
                {children}
            </main>

            <Footer />
        </div>
    );
}
